import LoginOrRegisterColumn from '../login/LoginOrRegisterColumn';
import React from 'react';
import { useTranslation } from 'react-i18next';
const AccountMenuGuest = (props) => {
    const { t } = useTranslation();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "a11y-action-bar" },
            React.createElement("a", { href: window.loginUrl },
                React.createElement("span", null, t('navigation.aria.navigatetologin')))),
        React.createElement(LoginOrRegisterColumn, Object.assign({}, props, { closeModal: props.closeMenu, inAccountMenu: true, linkreload: window.location.href, inModal: true, setForceReload: props.setForceReload, reloadComponent: true }))));
};
export default AccountMenuGuest;
